<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Доставка десертов</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <p style="margin-top:2%;">Заказывайте пирожные, блинчики, рулеты, мороженое прямо сейчас с доставкой домой и на работу.</p>
            <p>Огромное разнообразие вкуснейших сладостей в вашем городе на любой вкус. Тяжело удержаться от соблазна! Да и не надо себя сдерживать .</p>
            <p>Семейный ужин, торжество или просто пригласили домой друзей? Не нужно идти в магазин и покупать то, что придется. Заказывайте любимый десерт от лучших кондитерских г. {{city.name}}.</p>
            <p>Выбрали десерты? Не забудьте про <router-link to="/product/8">напитки</router-link>.</p>
            <p><br/><center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/dessert1.jpg" alt="Доставка десертов" width="700" /></center></p>
            <p style="margin-top:2%;">А может быть хотите <router-link to="/cake">заказать торт</router-link>? Выбирайте и заказывайте торт, который привезут прямо сейчас или на конкретную дату и даже время.</p>
            <p>Любите готовить сами? Готовьте с удовольствием с рецептами от шеф-поваров ресторанов, представленных на  <router-link to="/">хочу-поесть.рф</router-link>. Создавайте свои собственные шедевры – фруктовые салаты, тирамису, чизкейки и многое другое.</p>
            <router-link :to="'/product/5'" tag="div">
              <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'dessert',
  props: ['city']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/dessert.vue